import { User, UserManager, WebStorageStateStore } from 'oidc-client-ts';

export interface AppConfig {
  oidcIssuer: string;
  oidcClientId: string;
  adminAcr: string;
  adminIdleMin: number;
  incidentUrl: string;
  platformAddress: string;
}

let manager: UserManager | null = null;
let config: AppConfig | null = null;

// Адрес IdP и настройки фронт получает от API: одна сборка работает на любом стенде
export async function initAuth(): Promise<AppConfig> {
  if (config) return config;
  config = (await (await fetch('/api/config')).json()) as AppConfig;
  manager = new UserManager({
    authority: config.oidcIssuer,
    client_id: config.oidcClientId,
    redirect_uri: `${location.origin}/auth/callback`,
    post_logout_redirect_uri: `${location.origin}/`,
    response_type: 'code',
    scope: 'openid email profile',
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: sessionStorage }),
  });
  return config;
}

export const appConfig = () => config!;

export function auth(): UserManager {
  if (!manager) throw new Error('auth not initialized');
  return manager;
}

export async function currentUser(): Promise<User | null> {
  const user = await auth().getUser();
  if (user?.expired) {
    try {
      return await auth().signinSilent();
    } catch {
      return null;
    }
  }
  return user;
}

export async function currentToken(): Promise<string | null> {
  return (await currentUser())?.access_token ?? null;
}

/** acr текущего токена: gold = вход со вторым фактором (AUTH-03) */
export function tokenAcr(user: User | null): string | null {
  if (!user) return null;
  try {
    return JSON.parse(atob(user.access_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).acr ?? null;
  } catch {
    return null;
  }
}

export function login(returnTo = location.pathname + location.search) {
  return auth().signinRedirect({ state: returnTo });
}

/** Вход в админку: Keycloak спросит одноразовый код. fresh - после истечения сессии админки */
export function loginAdmin(returnTo = location.pathname + location.search, fresh = false) {
  return auth().signinRedirect({ state: returnTo, acr_values: config!.adminAcr, ...(fresh ? { max_age: 0 } : {}) });
}

export function logout() {
  return auth().signoutRedirect();
}
